import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container-fluid footer-wrapper">

        {/* Left Logos */}
        <div className="footer-logos">
          <img src="/images/footer4.jpg" alt="National Council for Hotel Management and Catering Technology" loading="lazy" />
          <img src="/images/ignou-nchmct.webp" alt="Indira Gandhi National Open University Logo" loading="lazy" />
          <img src="/images/footer2.png" alt="Ministry of Tourism, Government of India Logo" loading="lazy" />
        </div>

        {/* Right Social */}
        <div className="footer-social">
          <span>Follow Us</span>
          <a href="https://www.instagram.com/ihmmumbaiofficial" aria-label="Follow IHM Mumbai on Instagram" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-instagram" aria-hidden="true"></i>
          </a>
          <a href="https://www.facebook.com/IHMMUMBAI" aria-label="Follow IHM Mumbai on Facebook" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-facebook" aria-hidden="true"></i>
          </a>
          <a href="https://www.youtube.com/c/IHMMUMBAIOFFICIAL" aria-label="Subscribe to IHM Mumbai YouTube Channel" target="_blank" rel="noopener noreferrer">
            <i className="bi bi-youtube" aria-hidden="true"></i>
          </a>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
